import { EdgelessObject, normalizeResultScale, type IFramework, type IResultOptions } from '@/framework';
import { renderLayerContentToCanvas } from './render/render-to-canvas';

export class EdgelessQRCodeLayer extends EdgelessObject {
    private identity: string;

    constructor(layerId: string, framework: IFramework) {
        super(layerId, framework.service);
        this.identity = framework.identity;
    }

    private async getResource(scale = super.getResourceScale()) {
        const layer = this.service.flatLayer.getLayer(this.layerId);
        return renderLayerContentToCanvas(layer, false, scale);
    }

    override supportsCanvasResult() {
        return true;
    }

    override async getResult({ aiWatermark = false, scale = 1 }: IResultOptions = {}) {
        const renderBox = this.getBaseInfo();
        const canvas = await this.getResource(normalizeResultScale(scale));
        if (aiWatermark) {
            await super.drawAiWatermarkAsync(canvas);
        }
        return { canvas, renderBox };
    }

    override async loadResource() {
        const canvas = await this.getResource();
        await super.drawAiWatermarkAsync(canvas);
        return canvas;
    }
}
